jQuery(function ($) {
    if ( $('#lesson-accordion').length ) {
        //アコーディオン表示の高さを取得
        let lesson_accordion = document.getElementById('lesson-accordion');
        let innerheight = lesson_accordion.clientHeight;
        //アコーディオン表示の高さを0にする（初期表示は非表示）
        $('#lesson-accordion').css('max-height',0);
        //アコーディオン開閉ボタンクリック時
    	$('.program__accordion-button').on('click', function() {
            let closeButton = $('.program__accordion-button-text.is-close-button');
            let openButton = $('.program__accordion-button-text.is-open-button');
            if ( openButton.hasClass('is-active') ) {
                openButton.removeClass('is-active');
                closeButton.addClass('is-active');
                $('.program__accordion-button-inner').removeClass('is-open-button');
                $('#lesson-accordion').css('max-height',innerheight + 'px');
            } else {
                closeButton.removeClass('is-active');
                openButton.addClass('is-active');
                $('.program__accordion-button-inner').addClass('is-open-button');
                $('#lesson-accordion').css('max-height',0);
            }
    	});
    }
    if ( $('#js-infinit-scroll').length ) {
        let idx = -1;
        let view_max = 1;
        let elem = document.getElementById("json-data");
        let data = JSON.parse(elem.textContent);
        let data_max = data.length
        $(window).on("scroll", function () {
            if ( window.util.is_visible($('#js-infinit-scroll')) && idx + 1 < data_max ) {
                for ( let i = 0 ; i < view_max ; i ++ ) {
                    idx ++;
                    let addHtml = data[idx];
                    $('#js-infinit-scroll').before(addHtml);
                    $('.program__day.is_hidden').fadeIn();
                }
            }
        });
    }

});
